/**
 * Helper functions for html document
 */
export default class DocumentHelper {
  /**
   * Function to set an callback for when document 'DomContentLoaded' event is triggered
   * @param callback function to run when triggered
   */
  static onDomReady = callBack => {
    if (window.document.readyState === "loading")
      document.addEventListener("DOMContentLoaded", callBack);
    else callBack();
  };

  /**
   * Function to set an callback for when window 'load' event is triggered
   * @param callback  function to run when triggered
   */
  static onWindowReady = callBack => {
    if (document.readyState === "complete") callBack();
    else window.addEventListener("load", callBack);
  };

  /**
   * Function to set an callback for when an event is triggered
   * @param eventName name of the event to be triggered
   * @param callback function to run when triggered
   */
  static addEventListener(eventName, callback) {
    window.addEventListener(eventName, callback);
  }
}
